(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fooikos-color-lab-vote"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-color-lab-vote]').forEach((section) => {
    if (section.dataset.colorLabReady === 'true') return;
    section.dataset.colorLabReady = 'true';

    const storageKey = section.dataset.storageKey || 'fooikos-color-lab-v1';
    const form = section.querySelector('.fooikos-vote__form');
    const colorStep = section.querySelector('[data-vote-step="colors"]');
    const intentStep = section.querySelector('[data-vote-step="intent"]');
    const continueButton = section.querySelector('[data-vote-continue]');
    const backButton = section.querySelector('[data-vote-back]');
    const intentHeading = section.querySelector('[data-intent-heading]');
    const successPanel = section.querySelector('[data-vote-success]');
    const serverSuccess = section.querySelector('[data-vote-posted-successfully]');
    const selectionText = section.querySelector('[data-selection-text]');
    const selectedSwatch = section.querySelector('[data-selected-swatch]');

    const readSession = (suffix) => {
      try {
        return window.sessionStorage.getItem(`${storageKey}:${suffix}`);
      } catch (error) {
        return null;
      }
    };

    const writeSession = (suffix, value) => {
      try {
        window.sessionStorage.setItem(`${storageKey}:${suffix}`, value);
      } catch (error) {
        return;
      }
    };

    const showSuccess = () => {
      if (form) form.hidden = true;
      if (successPanel) successPanel.hidden = false;
      const selectedName = readSession('selected-name');
      const selectedHex = readSession('selected-hex');
      if (selectedName && selectionText) {
        const template = selectionText.dataset.template || 'You voted for [color].';
        selectionText.textContent = template.replace('[color]', selectedName);
      }
      if (selectedHex && selectedSwatch) {
        selectedSwatch.style.setProperty('--selected-swatch', selectedHex);
      }
    };

    if (serverSuccess) {
      writeSession('complete', 'true');
    }

    if (serverSuccess || readSession('complete') === 'true') {
      showSuccess();
      return;
    }

    if (!form || !colorStep || !intentStep || !continueButton) return;

    intentStep.hidden = true;
    const colorChoices = Array.from(form.querySelectorAll('[data-color-choice]'));

    const syncContinue = () => {
      continueButton.disabled = !colorChoices.some((choice) => choice.checked);
    };

    colorChoices.forEach((choice) => choice.addEventListener('change', syncContinue));
    syncContinue();

    continueButton.addEventListener('click', () => {
      const selected = colorChoices.find((choice) => choice.checked);
      if (!selected) return;
      colorStep.hidden = true;
      intentStep.hidden = false;
      intentHeading?.focus();
    });

    backButton?.addEventListener('click', () => {
      intentStep.hidden = true;
      colorStep.hidden = false;
      colorStep.querySelector('input:checked')?.focus();
    });

    form.addEventListener('submit', () => {
      const selected = colorChoices.find((choice) => choice.checked);
      if (!selected) return;
      writeSession('selected-name', selected.value);
      writeSession('selected-hex', selected.dataset.colorHex || '');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fooikos-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#fooikos-"]');
    var drawer = link && link.closest('details.menu-drawer-container[open]');
    if (!drawer) return;

    var destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== '/' || !destination.hash.startsWith('#fooikos-')) return;

    var target = document.getElementById(destination.hash.slice(1));
    if (!target) return;

    event.preventDefault();
    drawer.querySelector('summary')?.click();
    window.setTimeout(function () {
      window.history.pushState(null, '', destination.hash);
      target.scrollIntoView({ block: 'start' });
    }, 220);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fooikos-jewelry-detail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fooikos-jewelry-details')) {
  customElements.define('fooikos-jewelry-details', class extends HTMLElement {
    connectedCallback() {
      this.onColorChange = (event) => {
        const picker = event.target.closest?.('variant-picker');
        if (!picker || picker.dataset.productId !== this.dataset.productId || picker.dataset.templateProductMatch !== 'true') return;
        const option = event.target.selectedOptions?.[0] || event.target;
        const color = String(option.value || '').toLowerCase();
        if (color === 'white' || color === 'brown') this.dataset.color = color;
      };
      document.addEventListener('change', this.onColorChange);
    }
    disconnectedCallback() { document.removeEventListener('change', this.onColorChange); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fooikos-packing-set-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-fk-purchase]');
    if (!button) return;
    var section = button.closest('.fooikos-story');
    var configuredId = section && section.dataset.purchaseAnchor;
    var target = configuredId ? document.getElementById(configuredId) : null;
    if (!target) {
      var form = document.querySelector('form[action*="/cart/add"]');
      target = form && (form.closest('section') || form);
    }
    if (!target) target = document.getElementById('MainContent');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
